import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal } from "react-bootstrap";
import ScrollToBottom from "react-scroll-to-bottom";

import Button from "../../../components/common/button/Button";
import Message from "./Message/Message";
import SendForm from "./SendForm/SendForm";
import { formatDate } from "../../../utils/dates";

import { Mixpanel } from "../../../actions/mixpanel.actions";
import * as projectActions from "../../../actions/project.actions";

import noMessagesIcon from "../../../assets/images/no-messages-icon.svg";
import styles from "./Messages.scss";

class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolldown: false,
      show: props.show || false,
      editSelected: null,
      removeSelected: null
    };

    this.handleEditSelected = this.handleEditSelected.bind(this);
    this.handleRemoveOpen = this.handleRemoveOpen.bind(this);
    this.handleRemoveClose = this.handleRemoveClose.bind(this);
    this.submitMessage = this.submitMessage.bind(this);
    this.editMessage = this.editMessage.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
  }

  handleEditSelected(message) {
    this.setState({ editSelected: message });
  }

  handleRemoveOpen(message) {
    this.setState({ show: true, removeSelected: message.id });
  }

  handleRemoveClose() {
    this.setState({ show: false, removeSelected: null });
  }

  submitMessage(form) {
    const fileInput = document.getElementById("message-attachment");
    const attachment = fileInput.files[0];
    const formData = new FormData();

    formData.append("message", form.message || "Attachment:");
    formData.append("pitch_id", this.props.pitchId);

    if (attachment) {
      formData.append("attachment", attachment);
    }

    this.props.projectActions.sendMessage(formData);
    fileInput.value = "";

    Mixpanel.track("Project - Messages - Message Sent");
  }

  editMessage(form) {
    const formData = new FormData();

    if (form.message && form.message !== this.state.editSelected.message) {
      formData.append("pitch_id", this.props.pitchId);
      formData.append("message", form.message);

      this.props.projectActions.editMessage(
        this.state.editSelected.id,
        formData
      );

      Mixpanel.track("Project - Messages - Message Edited");
    }

    this.handleEditSelected(null);
  }

  removeMessage(messageId, pitchId) {
    this.props.projectActions.removeMessage(messageId, pitchId);
    Mixpanel.track("Project - Messages - Message Removed");
  }

  downloadAttachment(messageId) {
    if (!this.props.project.loadingMessageAttachment) {
      this.props.projectActions.downloadMessageAttachment(messageId);
      Mixpanel.track("Project - Messages - Download Attachment");
    }
  }

  render() {
    return (
      <div className={styles.messages}>
        {this.renderContent()}
        {this.renderModal()}
      </div>
    );
  }

  renderModal() {
    return (
      <Modal
        show={this.state.show}
        onHide={this.handleRemoveClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <div className={styles.title}>
            Are you sure you want to delete the selected message?
          </div>
          <div className={styles.dividerDouble} />

          <div className={styles.CTAContainer}>
            <Button
              isPrimary
              isSmall
              label="Yes"
              onClick={() => {
                this.removeMessage(
                  this.state.removeSelected,
                  this.props.pitchId
                );
                this.handleRemoveClose();
              }}
            />

            <Button
              isSecondary
              isSmall
              label="No"
              onClick={() => {
                this.handleRemoveClose();
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderContent() {
    const { disabled } = this.props;

    return disabled
      ? this.renderDisabledMessage()
      : this.renderMessagesContainer();
  }

  renderDisabledMessage() {
    return (
      <div className={styles.noMessages}>
        <img
          src={noMessagesIcon}
          alt="noMessagesIcon"
          className={styles.noMessagesIcon}
        />
        <div className={styles.noMessagesText}>
          Pitch this project to chat <br /> with the Company.
        </div>
      </div>
    );
  }

  renderMessagesContainer() {
    return (
      <React.Fragment>
        <ScrollToBottom scrollViewClassName={styles.messagesContainer}>
          {this.renderMessagesHeader()}
          {this.renderMessages()}
        </ScrollToBottom>
        <SendForm onSubmit={this.submitMessage} />
      </React.Fragment>
    );
  }

  renderMessagesHeader() {
    const { matchDate } = this.props;
    const formattedDate = formatDate(matchDate, "MMM DD, YYYY [at] h:mm A");
    const role = localStorage.getItem("role");
    const text =
      role === "member"
        ? "You were matched to this project on"
        : "You were matched to this member on";

    return (
      <div className={styles.lineText}>
        <div className={styles.lineTextContent}>
          {text} {formattedDate}
        </div>
      </div>
    );
  }

  renderMessages() {
    const { messages, project, pitchId, memberId } = this.props;
    const { editSelected } = this.state;

    return (
      messages &&
      messages.map((message, key) => {
        const props = {
          onSubmit: this.editMessage,
          handleEditSelected: this.handleEditSelected,
          handleRemoveOpen: this.handleRemoveOpen,
          downloadAttachment: this.downloadAttachment,
          loading: project.loadingMessageAttachment,
          key,
          message,
          editSelected,
          isEditing: message && editSelected && message.id === editSelected.id,
          pitchId,
          memberId,
          project
        };

        return <Message {...props} />;
      })
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    loading: state.common.loading.length > 0
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Messages);



// WEBPACK FOOTER //
// ./src/routes/common/messages/Messages.js